module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-conseil-experts-cernes.47ff5c77.jpg";